import { Container } from '@mui/material';
import { HeaderBreadcrumbs, Page } from '@/components';
import useSettings from '@/hooks/useSettings';
import { PATH_USER } from '@/features/app';
import AuditTrailWidget from '../components/AuditTrailWidget';

export default function AuditLogsList() {
  const { themeStretch } = useSettings();

  return (
    <Page title="Audit Logs">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Audit Logs"
          links={[
            { name: 'Dashboard', href: PATH_USER.root },
            { name: 'System' },
            { name: 'Audit Logs' },
          ]}
        />

        <AuditTrailWidget height="28rem" />
      </Container>
    </Page>
  );
}
